var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRank = function SvgRank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v23.076a2 2 0 0 1-2.725 1.864l-8.913-3.466a1 1 0 0 0-.724 0L2.725 26.94A2 2 0 0 1 0 25.076z"
  })));
};
export default SvgRank;